import { Content } from "@/components/layouts/content";
import { Header } from "@/components/layouts/header";
import { articleStatuses } from "@/constants/article-statuses";
import { articleQueryOptions } from "@/features/dashboard/api/queries/article-query";
import ArticleEditor from "@/features/dashboard/components/article-editor";
import ArticleView from "@/features/dashboard/components/article-view";
import { useAuth } from "@/hooks/use-auth";
import { useSuspenseQuery } from "@tanstack/react-query";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_dashboard/articles_/$articleId")({
	loader: ({ context: { queryClient }, params }) => {
		return queryClient.ensureQueryData(articleQueryOptions(params.articleId));
	},
	component: ArticleShow,
});

function ArticleShow() {
	const params = Route.useParams();
	const articleQuery = useSuspenseQuery(articleQueryOptions(params.articleId));
	const data = articleQuery.data;
	const { user } = useAuth();

	return (
		<Content pageName="Articles">
			{/*<Header title="Articles" />*/}
			{data.created_by === user?.id && data.status !== articleStatuses.APPROVED && data.status !== articleStatuses.PENDING ? (
				<ArticleEditor data={data} key={data.id} />
			) : (
				<ArticleView article={data} key={data.id} />
			)}
		</Content>
	);
}
